import React from 'react'
import {render} from 'react-dom'
import {Provider} from 'react-redux'
import 'core-js'
import store from './store'
import Signup from './components/Signup'

require("../assets/sass/launcher.scss")

render(
  <Provider store={store}>
    <Signup/>
  </Provider>,
  document.getElementById('Signup')
)
